/**
 * Equal Offense API Service
 * Handles all API calls for Equal Offense sessions and frames
 */
import apiClient from '../apiClient';

const SESSIONS_URL = '/api/equal-offense/sessions';
const FRAMES_URL = '/api/equal-offense/frames';

// ============================================================================
// SESSION ENDPOINTS
// ============================================================================

/**
 * Get all sessions
 */
export const getSessions = async () => {
  const response = await apiClient.get(`${SESSIONS_URL}/`);
  return response.data;
};

/**
 * Get single session by ID
 */
export const getSession = async (id) => {
  const response = await apiClient.get(`${SESSIONS_URL}/${id}/`);
  return response.data;
};

/**
 * Create new session
 */
export const createSession = async (sessionData) => {
  const response = await apiClient.post(`${SESSIONS_URL}/`, sessionData);
  return response.data;
};

/**
 * Update session
 */
export const updateSession = async (id, sessionData) => {
  const response = await apiClient.patch(`${SESSIONS_URL}/${id}/`, sessionData);
  return response.data;
};

/**
 * Delete session
 */
export const deleteSession = async (id) => {
  const response = await apiClient.delete(`${SESSIONS_URL}/${id}/`);
  return response.data;
};

/**
 * Finish session
 */
export const finishSession = async (id, winnerId = null) => {
  const response = await apiClient.post(`${SESSIONS_URL}/${id}/finish/`, {
    winner: winnerId
  });
  return response.data;
};

/**
 * Get session statistics
 */
export const getSessionStats = async () => {
  const response = await apiClient.get(`${SESSIONS_URL}/stats/`);
  return response.data;
};

/**
 * Get sessions by stufe (level)
 */
export const getSessionsByStufe = async (stufe) => {
  const response = await apiClient.get(`${SESSIONS_URL}/by_stufe/`, {
    params: { stufe }
  });
  return response.data;
};

// ============================================================================
// FRAME ENDPOINTS
// ============================================================================

/**
 * Get all frames
 */
export const getFrames = async () => {
  const response = await apiClient.get(`${FRAMES_URL}/`);
  return response.data;
};

/**
 * Get frames by session
 */
export const getFramesBySession = async (sessionId) => {
  const response = await apiClient.get(`${FRAMES_URL}/by_session/`, {
    params: { session: sessionId }
  });
  return response.data;
};

/**
 * Create new frame
 */
export const createFrame = async (frameData) => {
  console.log('Creating frame with data:', frameData);
  const response = await apiClient.post(`${FRAMES_URL}/`, frameData);
  console.log('Frame created, response:', response.data);
  return response.data;
};

/**
 * Delete frame
 */
export const deleteFrame = async (id) => {
  const response = await apiClient.delete(`${FRAMES_URL}/${id}/`);
  return response.data;
};

// ============================================================================
// HELPER CONSTANTS
// ============================================================================

export const STUFE_CHOICES = [
  { value: 1, label: 'Stufe 1: Anfänger', description: 'Ball-in-Hand, 3 Leben, 10 Aufnahmen' },
  { value: 2, label: 'Stufe 2: Fortgeschritten', description: 'Ball-in-Hand, 2 Leben, 10 Aufnahmen' },
  { value: 3, label: 'Stufe 3: Amateur', description: 'Ball-in-Hand, 1 Leben, 10 Aufnahmen' },
  { value: 4, label: 'Stufe 4: Geübt', description: 'Kein BIH, 3 Leben, 10 Aufnahmen' },
  { value: 5, label: 'Stufe 5: Beinahe Profi', description: 'Kein BIH, 2 Leben, 10 Aufnahmen' },
  { value: 6, label: 'Stufe 6: Profi', description: 'Kein BIH, 1 Leben, 10 Aufnahmen' },
  { value: 7, label: 'Stufe 7: God-Mode', description: 'Min. 250 Punkte, Rebuild bei 14, unbegrenzt' },
];

export const getStufeInfo = (stufe) => {
  return STUFE_CHOICES.find(s => s.value === stufe) || STUFE_CHOICES[0];
};
